"use client"

import { useState } from "react"
import ProfessorForm from "../components/Professores/ProfessorForm"
import ProfessorList from "../components/Professores/ProfessorList"
import "../styles/ProfessoresPage.css"

export default function ProfessoresPage() {
  const [updateList, setUpdateList] = useState(false)
  const [professorParaEditar, setProfessorParaEditar] = useState(null)

  const handleAdded = () => {
    setUpdateList((prev) => !prev)
    setProfessorParaEditar(null)
  }

  const handleEdit = (professor) => {
    setProfessorParaEditar(professor)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleCancelEdit = () => {
    setProfessorParaEditar(null)
  }

  return (
    <div className="professores-page">
      <h1 className="page-title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        Gestão de Professores
      </h1>

      <ProfessorForm onAdded={handleAdded} professorParaEditar={professorParaEditar} onCancelEdit={handleCancelEdit} />

      <ProfessorList keyProp={updateList} onEdit={handleEdit} />
    </div>
  )
}
